import { render } from "./Stages.vue?vue&type=template&id=27435ce0&scoped=true"
import script from "./Stages.vue?vue&type=script&lang=js"
export * from "./Stages.vue?vue&type=script&lang=js"

import "./Stages.vue?vue&type=style&index=0&id=27435ce0&scoped=true&lang=css"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27435ce0"]])

export default __exports__